import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import BenevolCheckLogo from '../components/BenevolCheckLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/forgot-password`, { email });
      console.log('Forgot password response:', response);
      setSuccess(true);
    } catch (error) {
      console.error('Forgot password error:', error);
      console.error('Error response:', error.response);
      const errorMessage = error.response?.data?.detail || error.message || 'Erreur lors de l\'envoi de l\'email';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md" data-testid="forgot-password-card">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <BenevolCheckLogo size="lg" />
          </div>
          <CardTitle className="text-2xl">Mot de passe oublié</CardTitle>
          <CardDescription>
            Entrez votre email pour recevoir un lien de réinitialisation
          </CardDescription>
        </CardHeader>

        {success ? (
          <CardContent>
            <Alert className="bg-green-50 border-green-200" data-testid="success-alert">
              <AlertDescription className="text-green-800">
                ✅ Si un compte existe avec cet email, vous recevrez un lien de réinitialisation dans quelques instants.
                <br /><br />
                Vérifiez votre boîte de réception (et vos spams).
              </AlertDescription>
            </Alert>
            <div className="mt-6 text-center">
              <Link 
                to="/login" 
                className="text-indigo-600 hover:underline"
                data-testid="back-to-login"
              >
                ← Retour à la connexion
              </Link>
            </div>
          </CardContent>
        ) : (
          <form onSubmit={handleSubmit}>
            <CardContent className="space-y-4">
              {error && (
                <Alert variant="destructive" data-testid="error-alert">
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}
              
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="votre@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="email-input"
                />
                <p className="text-sm text-gray-600">
                  Nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>
              </div>
            </CardContent>
            
            <CardFooter className="flex flex-col gap-4">
              <Button 
                type="submit" 
                className="w-full" 
                disabled={loading}
                data-testid="submit-button"
              >
                {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </Button>
              
              <Link 
                to="/login" 
                className="text-sm text-center text-gray-600 hover:underline"
                data-testid="back-link"
              >
                ← Retour à la connexion
              </Link>
            </CardFooter>
          </form>
        )}
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;